import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const VendorIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 10v10h16V10M3 10l2-6h14l2 6" />
      <path d="M3 10c0 1.4 1 2.3 2.2 2.3S7.4 11.4 7.4 10c0 1.4 1 2.3 2.3 2.3S12 11.4 12 10c0 1.4 1 2.3 2.3 2.3s2.3-.9 2.3-2.3c0 1.4 1 2.3 2.2 2.3S21 11.4 21 10" />
      <path d="M9 20v-5h6v5" />
    </g>
  </SvgIcon>
)

export default VendorIcon
